import React from 'react';
import InteractiveChart from './InteractiveChart';

function App() {
    return (
        <div>
            <h1 className="text-center text-xl mt-4">金额走势展示</h1>
            <InteractiveChart/>
        </div>
    );
}

export default App;
